// extracted by mini-css-extract-plugin
export var content = "_pa-1";
export var noScroll = "_pa-3";
export var paper = "_pa-0";
export var scrollable = "_pa-2";